<template>
    <div class="filter-sorts">
        <div class="filter-btn" @click="addFormListener">
           <i class="icon-sort-by"></i> Sort by: {{ sorted[ sortOption ] || '' }}
        </div>
        <div class="filter-container" :style="`opacity: ` + (isFilter ? '1': '0; display:none')" ref="filterMenu">
            <div :class="[
                    'filter-item-btn',
                    sortOption === 'newest' ? 'active' : ''
                ]"
                @click="applySort('newest')"
            >Newest</div>
            <div :class="[
                    'filter-item-btn',
                    sortOption === 'lowToHigh' ? 'active' : ''
                ]"
                @click="applySort('lowToHigh')"
            >Price low to high</div>
            <div :class="[
                    'filter-item-btn',
                    sortOption === 'highToLow' ? 'active' : ''
                ]"
                @click="applySort('highToLow')"
            >Price high to low</div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "productFilters",
    data() {
        return {
            stats: window.stats || [],
            NumberFormat: {},

            isFilter: false,
            sortOption: 'newest',
            sorted: {
                newest: 'Newest',
                lowToHigh: 'Price low to high',
                highToLow: 'Price high to low',
            }
        };
    },
    mounted() {
        this.sortOption = this.determineSortOrder()
    },
    beforeUnmount() {
        this.removeClickListener();
    },
    created() {
        this.NumberFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: this.stats.currency || 'USD'});
    },
    methods: {
        determineSortOrder() {

            // Получаем параметры из URL
            const params = new URLSearchParams( window.location.search );
            const orderBy = params.get('order_by');
            const order   = params.get('order');

            // Определяем активный режим сортировки
            let activeSort = 'newest';
            if( orderBy === 'created' ) {
                activeSort = 'newest';
            } else if ( orderBy === 'sale_price' && order === 'asc' ) {
                activeSort = 'lowToHigh';
            } else if ( orderBy === 'sale_price' && !order ) {
                // Если order не указан, считаем это highToLow (по умолчанию для sale_price)
                activeSort = 'highToLow';
            }

            return activeSort;
        },
        applySort( value ) {

            const currentParams = new URLSearchParams(window.location.search);
            const newParams = new URLSearchParams();

            // Сохраняем все текущие параметры, кроме order_by и order
            for (const [key, val] of currentParams) {
                if (key !== 'order_by' && key !== 'order') {
                    newParams.append(key, val);
                }
            }

            // Добавляем новые параметры сортировки
            switch (value) {
                case 'newest':
                    newParams.set('order_by', 'created');
                    break;
                case 'lowToHigh':
                    newParams.set('order_by', 'sale_price');
                    newParams.set('order', 'asc');
                    break;
                case 'highToLow':
                    newParams.set('order_by', 'sale_price');
                    // order не добавляем (по умолчанию)
                    break;
            }

            this.sortOption = value;
            window.location.href =
                window.location.origin +
                window.location.pathname +
                '?' + newParams.toString();
        },

        async addFormListener() {
            try {
                // Ждем, пока меню полностью откроется
                await this.openForm()
                document.addEventListener('click', this.handleClickOutside, { passive: false })
            } catch (error) {
                console.error('Error when try to open form:', error)
            }
        },
        openForm() {
            return new Promise((resolve) => {
                // открываем форму search
                this.isFilter = true;

                // добавить анимацию или другие асинхронные операции?
                setTimeout(() => {
                    resolve()
                }, 300)
            })
        },
        closeForm() {
            this.isFilter = false;
            this.removeClickListener()
        },

        // Удаление слушателя клика
        removeClickListener() {
            document.removeEventListener( 'click', this.handleClickOutside )
        },

        // Обработка клика вне компонента
        handleClickOutside(event ) {
            const c1 = document.querySelector('.filter-container')
            if( this.$refs.filterMenu && this.isFilter && ! c1.contains( event.target ) )
                this.closeForm()
        },

        // Обработка клика внутри контента
        handleContentClick( event ) {
            this.handleClickOutside( event );
            event.stopPropagation() // Останавливаем распространение события
        },
    },
});
</script>

<style lang="scss" scoped>

</style>
